import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { useMultiStyleConfig as i, Flex as s } from "@chakra-ui/react";
import { SgiLogo as l } from "../../branding/SgiLogo/SgiLogo.mjs";
import { SgiCanadaLogo as e } from "../../branding/SgiCanadaLogo/SgiCanadaLogo.mjs";
const p = () => {
  const r = i("GlobalFooter");
  return /* @__PURE__ */ t(s, { sx: r.logos, children: [
    /* @__PURE__ */ o(l, { variant: "grayscale", width: "98.5px" }),
    /* @__PURE__ */ o(e, { width: "69.4px" })
  ] });
};
export {
  p as GlobalFooterLogos
};
